import React, { Component } from 'react';
import { Col, ListGroup, ListGroupItem, Row } from 'react-bootstrap';
import { nonScienceRequirements, scienceRequirements, ptRequirements } from "../config/constants";
import {connect} from "react-redux";

class EducationRequirements extends Component {
  processRequirement(requirement) {
    const { colleges } = this.props.educationInfo;
    let repeats = 0;
    let status = false;
    for(let college of colleges) {
      for(let course of college.courses) {
        if(course.requirement === requirement) {
          if(course.repeat)
            repeats++;
          else {
            if(EducationRequirements.calculateGradePointsForGrade(course.grade) < 2.0)
              continue;
            status = true;
          }
        }
      }
    }
    return {
      status,
      repeats
    };
  }

  static calculateGradePointsForGrade(grade){
    let courseGradePoints;
    if(!grade) return 0.0;
    switch(grade.charAt(0)){
      case "A":
        courseGradePoints = 4.0;
        break;
      case "B":
        courseGradePoints = 3.0;
        break;
      case "C":
        courseGradePoints = 2.0;
        break;
      case "D":
        courseGradePoints = 1.0;
        break;
      default:
        courseGradePoints = 0.0;
    }
    if(grade.length === 2)
      switch(grade.charAt(1)){
        case "-":
          courseGradePoints = courseGradePoints - 0.3;
          break;
        case "+":
          courseGradePoints = courseGradePoints + 0.3;
          break;
        default:
          break;
      }
    return courseGradePoints;
  }

  processScienceGPA(){
    const { colleges } = this.props.educationInfo;
    let scienceGradePoints = 0.0;
    let scienceUnits = 0.0;
    for(let college of colleges) {
      for(let course of college.courses) {
        if((Object.keys(scienceRequirements).includes(course.requirement)) &&
          !course.repeat &&
          course.units &&
          course.units !== "" &&
          course.grade &&
          course.grade !== "" &&
          course.grade !== "EW" && // Forgive EW
          college.unitType &&
          college.unitType !== ""){
          let courseUnits = college.unitType === 'S' ? parseFloat(course.units) : 0.6667 * course.units;
          let courseGradePoints = EducationRequirements.calculateGradePointsForGrade(course.grade);
          scienceGradePoints += courseGradePoints * courseUnits;
          scienceUnits += courseUnits;
        }
      }
    }

    const gpa = scienceUnits > 0 ? scienceGradePoints / scienceUnits : 0.0;
    return {
      gpa,
      style: gpa > 2.5 ? 'success' : gpa === 0.0 ? 'warning' : 'danger'
    }
  }

  processNonScienceGPA(){
    const { colleges } = this.props.educationInfo;
    let nonScienceGradePoints = 0;
    let nonScienceUnits = 0;
    for(let college of colleges) {
      for(let course of college.courses) {
        if((Object.keys(nonScienceRequirements).includes(course.requirement)) &&
          !course.repeat &&
          course.units &&
          course.units !== "" &&
          course.grade &&
          course.grade !== "" &&
          course.grade !== "EW" && // Forgive EW
          college.unitType &&
          college.unitType !== ""){
          let courseUnits = college.unitType === 'S' ? parseFloat(course.units) : 0.6667 * course.units;
          let courseGradePoints = EducationRequirements.calculateGradePointsForGrade(course.grade);
          nonScienceGradePoints += courseGradePoints * courseUnits;
          nonScienceUnits += courseUnits;
        }
      }
    }

    const gpa = nonScienceUnits > 0 ? nonScienceGradePoints / nonScienceUnits : 0.0;
    return {
      gpa,
      style: gpa > 2.5 ? 'success' : gpa === 0.0 ? 'warning' : 'danger'
    }
  }

  render() {
    const anatomyStatus = this.processRequirement('anatomy');
    const physiologyStatus = this.processRequirement('physiology');
    const microStatus = this.processRequirement('micro');
    const englishStatus = this.processRequirement('english');
    const nutritionStatus = this.processRequirement('nutrition');
    const mathStatus = this.processRequirement('math');
    const humanDevStatus = this.processRequirement('humanDev');
    const pharmacologyStatus = this.processRequirement('pharmacology');
    const medTerminologyStatus = this.processRequirement('medTerminology');
    const nursingSynthesisStatus = this.processRequirement('nursingSynthesis');
    const scienceGPA = this.processScienceGPA();
    const nonScienceGPA = this.processNonScienceGPA();

    return (
      <Row>
        <Col md={3}>
          <h4>Science Course Requirements</h4>
          <ListGroup>
            <ListGroupItem bsStyle={anatomyStatus.status ? 'success' : 'danger'} header="Human Anatomy">
              {anatomyStatus.repeats > 0 ? 'Repeats: ' + anatomyStatus.repeats : ''}
            </ListGroupItem>
            <ListGroupItem bsStyle={physiologyStatus.status ? 'success' : 'danger'} header="Human Physiology">
              {physiologyStatus.repeats > 0 ? 'Repeats: ' + physiologyStatus.repeats : ''}
            </ListGroupItem>
            <ListGroupItem bsStyle={microStatus.status ? 'success' : 'danger'} header="Microbiology">
              {microStatus.repeats > 0 ? 'Repeats: ' + microStatus.repeats : ''}
            </ListGroupItem>
          </ListGroup>
        </Col>
        <Col md={3}>
          <h4>Non-Science Course Requirements</h4>
          <ListGroup>
            <ListGroupItem bsStyle={englishStatus.status ? 'success' : 'danger'} header="English Composition">
              {englishStatus.repeats > 0 ? 'Repeats: ' + englishStatus.repeats : ''}
            </ListGroupItem>
            <ListGroupItem bsStyle={humanDevStatus.status ? 'success' : 'danger'} header="Human Development">
              {humanDevStatus.repeats > 0 ? 'Repeats: ' + humanDevStatus.repeats : ''}
            </ListGroupItem>
          </ListGroup>
          <h4>Non-GPA Course Requirements</h4>
          <ListGroup>
            <ListGroupItem bsStyle={mathStatus.status ? 'success' : 'danger'} header="Math"/>
          </ListGroup>
        </Col>
        <Col md={3}>
          <h4>Recommended Courses</h4>
          <ListGroup>
            <ListGroupItem bsStyle={nutritionStatus.status ? 'success' : 'warning'} header="Nutrition"/>
            <ListGroupItem bsStyle={pharmacologyStatus.status ? 'success' : 'warning'} header="Pharmacology"/>
            <ListGroupItem bsStyle={medTerminologyStatus.status ? 'success' : 'warning'} header="Medical Terminology"/>
          </ListGroup>
        </Col>
        <Col md={3}>
          <h4>GPA Requirements</h4>
          <ListGroup>
            <ListGroupItem bsStyle={scienceGPA.style}>
              Science GPA: {scienceGPA.gpa.toPrecision(4)}
            </ListGroupItem>
            <ListGroupItem bsStyle={nonScienceGPA.style}>
              Non-Science GPA: {nonScienceGPA.gpa.toPrecision(4)}
            </ListGroupItem>
          </ListGroup>
          <h4>Upgrade Requirements</h4>
          <ListGroup>
            <ListGroupItem bsStyle={nursingSynthesisStatus.status ? 'success' : 'warning'} header="Nursing Synthesis" />
          </ListGroup>
        </Col>
      </Row>
    );
  };
}

export default connect(
  (state) => {
    const { appInfo, educationInfo } = state;
    const { programId } = appInfo.application;
    return {
      educationInfo,
      programId
    };
  }
)(EducationRequirements);